import { TextField } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon';
import InputFieldWrapper from '../InputFieldWrapper';

interface SearchBarProps {
  loading?: boolean;
  value?: string;
  maxLength?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  width?: string | number;
  clear?: () => void;
  reset?: () => void;
}

function SearchBar(props: SearchBarProps) {
  const { onChange, maxLength, ...rest } = props;

  const [maxLengthError, setMaxLengthError] = React.useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      if (maxLength && e.target.value.length > maxLength) {
        setMaxLengthError(true);
        return;
      }
      setMaxLengthError(false);
      onChange(e);
    }
  }
  return (
    <InputFieldWrapper errorText={maxLengthError ? `Max length of ${maxLength} exceeded` : undefined}>
      <TextField.Root
        {...rest}
        onChange={handleChange}
      >
        <TextField.Slot>
          <Icon
            name='search-dark-medium'
            width={16}
            height={16}
          />
        </TextField.Slot>
      </TextField.Root>
    </InputFieldWrapper>
  );
}

SearchBar.propTypes = {
  loading: PropTypes.bool,
};

export default SearchBar;
